import CommonPasswordReset from '../../../common/pages/public/PasswordReset'

class PasswordReset extends CommonPasswordReset {
  constructor (props) {
    super(props)
    this.passwordResetFormTitle = '日本型枠工事業協会'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
}

export default PasswordReset



// WEBPACK FOOTER //
// ./src/company_user/pages/public/PasswordReset.js